import React, {useEffect, useState} from 'react'
import ContentSection from "./ContentSection";
import ContentHeader from "./ContentHeader";
import ContentSelector from "./ContentSelector";
import ContentStatus from "./ContentStatus";


function ContentEditor({
                            locationIds, localPagesContentList, localPagesTemplateList,
                            singleLocationMode, locationPatch, localPagesBrandList,
                            selectedLocations, setFormIsDirty
                        }) {

    const [localPagesContent, setLocalPagesContent] = useState(null);

    const singleLocation = locationPatch


    const updatePatch = (content, createMode = false) => {
        if (singleLocationMode) {
            locationPatch.localPages = {
                brandId: content.brandId,
                localPagesContent: {templateId: content.templateId, templateFieldsAndSections: createMode ? content.templateFieldsAndSections:[]}
            }
        } else {
            //If multiple locations are selected get the brandId from the location on the back end.
            locationPatch.localPages = {
                localPagesContent: {templateId: content.templateId, templateFieldsAndSections: []}
            }
        }
    }

    const contentSelected = (content, createMode=false) => {
        setLocalPagesContent(content)
        updatePatch(content, createMode)
    }

    const brandSelected = (brand) => {
        locationPatch.localPagesBrandId = !!brand ? brand._id : null
    }

    const shouldShowLocationInformation = () => {
        return singleLocationMode && !!localPagesContent && localPagesContent.templateFieldsAndSections.length > 0
    }

    const shouldShowContentHeader = () => {
        return !!localPagesContent && localPagesContent.templateFieldsAndSections.length > 0
    }

    return (
        <div>

            <ContentSelector
                localPagesContentList={localPagesContentList}
                localPagesTemplateList={localPagesTemplateList}
                contentSelectionFunction={contentSelected}
                selectedBrandId={locationPatch.localPagesBrandId}
                localPagesBrandList={localPagesBrandList}
                singleLocationMode={singleLocationMode}
                brandSelectionFunction={brandSelected}
                locationIds={locationIds}
            />

            <form>
                {shouldShowContentHeader() && <div><ContentHeader
                    shouldShowLocationInformation={shouldShowLocationInformation()}
                    singleLocation={singleLocation}
                />
                    <ContentStatus
                        locationPatch={locationPatch}
                        localPagesContent={localPagesContent}
                        setFormIsDirty={setFormIsDirty}
                    />
                </div>
                }

                {!!localPagesContent && localPagesContent.templateFieldsAndSections.map((section, index) =>
                    <ContentSection
                        key={"section-" + index}
                        section={section}
                        singleLocationMode={singleLocationMode}
                        locationPatch={locationPatch}
                        setFormIsDirty={setFormIsDirty}
                    />)
                }
            </form>
        </div>
    )


}

export default ContentEditor